import {
  TGetClustersForMapResponse,
  IGetClustersForMapResponse200,
} from 'shared/common/repositories/search-offers-index/v1/get-clusters-for-map';

import { ResponseError } from '../../../utils/errors/ResponseError';

export function assertUnknownError(
  response: TGetClustersForMapResponse,
): asserts response is IGetClustersForMapResponse200 {
  if (response.statusCode !== 400) {
    return;
  }

  const { message, errors } = response.response;

  const mergedMessage = `${message}${
    errors &&
    typeof errors === 'object' &&
    ` (${errors
      .filter((e): e is { message: string } => 'message' in e)
      .map(e => e.message)
      .join('; ')})`
  }`;

  throw new ResponseError({
    domain: 'shared/services/clusters/assert#assertUnknownError()',
    message: mergedMessage,
    details: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      errors: errors as any,
    },
  });
}
